import {Scope} from 'Shared/constants/Scope';

export type RequireScopeProps = {
  scope: Scope;
  scopes: Scope[];
  children: JSX.Element;
};

export const hasScope = (scopes: Scope[]) => (scope: Scope) => scopes?.includes(scope);

const RequireScope = (props: RequireScopeProps) => {
  if(props.hasOwnProperty('scopes') && props.scopes.length > 1) {
    return props.scopes?.includes(props.scope) ? props.children : null;
  }

  return null
};

export default RequireScope;
